import api from "./api";

const ChatbotManagementAPI = {
    getDataChatBotById: (id) => api.get(`/chatbot-management/details/${id}`),
    validateDataChatbot: (data) => api.post(`/chatbot-management/validate`, data),
    insUpdQuestion: (questions, answerId) => api.post(`/chatbot-management/question/${answerId}`, questions),
    updAnswer: (data) => api.post(`/chatbot-management/answer`, data),
    insDataChatbot: (data) => api.post(`/chatbot-management/insert`, data),
    importDataChatbot: (data) => api.post(`/chatbot-management/import`, data),
    startExport: () => api.get(`/chatbot-management/export/start`),
    getStatusExport: (jobId) => api.get(`/chatbot-management/export/status/${jobId}`),
    removeJob: (jobId) => api.get(`/chatbot-management/export/remove-job/${jobId}`),
    exportDataChatbot: (jobId) => api.get(`/chatbot-management/export/download/${jobId}`, {responseType: "blob"}),
    deleteQuestion: (id) => api.post(`/chatbot-management/delete/question/${id}`),
    deleteAnswer: (id) => api.post(`/chatbot-management/delete/answer/${id}`),
    deleteDuplicateQuestion: () => api.get(`/chatbot-management/qna/duplicate`)
};

export default ChatbotManagementAPI;